import { OrderOrigin } from '../../graphql/schema/p4types';
import { IStatusFlagStatus } from '../../components/connectedForm/HeaderBlock/HeaderBlock';
import { StatusStyle } from '../../components/connectedForm/HeaderStatus';

export const originStatuses: Array<IStatusFlagStatus> = [
  {
    value: OrderOrigin.Import,
    style: StatusStyle.Info,
    title: 'Imported',
  },
  {
    value: OrderOrigin.Ebay,
    style: StatusStyle.Danger,
    title: 'eBay',
  },
  {
    value: OrderOrigin.Amazon,
    style: StatusStyle.Warning,
    title: 'Amazon',
  },
  {
    value: OrderOrigin.AmazonPrime,
    style: StatusStyle.Warning,
    title: 'Amazon Prime',
  },
  {
    value: OrderOrigin.AmazonFba,
    style: StatusStyle.Warning,
    title: 'Amazon FBA',
  },
  {
    value: OrderOrigin.Pixsell,
    style: StatusStyle.Success,
    title: 'PixSell',
  },
  {
    value: OrderOrigin.Shopify,
    style: StatusStyle.Success,
    title: 'Shopify',
  },
  {
    value: OrderOrigin.Woocommerce,
    style: StatusStyle.Success,
    title: 'WooCommerce',
  },
  {
    value: OrderOrigin.Etsy,
    style: StatusStyle.Warning,
    title: 'Etsy',
  },
  {
    value: OrderOrigin.Xedi,
    style: StatusStyle.Danger,
    title: 'XEDI',
  },
  {
    value: OrderOrigin.Web,
    style: StatusStyle.Info,
    title: 'Web',
  },
  {
    value: OrderOrigin.BigCommerce,
    style: StatusStyle.Info,
    title: 'BigCommerce',
  },
  {
    value: OrderOrigin.Magento,
    style: StatusStyle.Danger,
    title: 'Magento',
  },
];
